import { Component, effect, inject, OnInit } from '@angular/core';
import { DataLayerStore } from '../../../stores/data-layer/data-layer.state';
import { DataLayerTypeStore } from '../../../stores/data-layer-type/data-layer-type.state';
import { IndicatorDataStore } from '../../../stores/indicatpr-data/indicator-data.state';
import { IndicatorData } from '../../../models/indicator-data';
import { MenuItem } from 'primeng/api';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { Button, ButtonDirective } from 'primeng/button';
import { getState } from '@ngrx/signals';
import { GeoDataStore } from '../../../stores/geo/geo-data.state';
import { GlobalsStore } from '../../../stores/globals.state';

@Component({
  selector: 'app-district-report-dropdown',
  standalone: true,
  imports: [TieredMenuModule, ButtonDirective, Button],
  templateUrl: './district-report-dropdown.component.html',
  styleUrl: './district-report-dropdown.component.scss',
})
export class DistrictReportDropdownComponent implements OnInit {
  readonly globalStore = inject(GlobalsStore);
  readonly geoStore = inject(GeoDataStore);
  readonly layerStore = inject(DataLayerStore);
  readonly indicatorStore = inject(IndicatorStore);
  readonly typeStore = inject(DataLayerTypeStore);
  readonly dataStore = inject(IndicatorDataStore);

  constructor() {
    effect(() => {
      const indicatorState = getState(this.indicatorStore);
      this.init();
    });
  }
  dataLayerMenu: MenuItem[] = [];

  ngOnInit() {
    this.init();
  }

  /**
   * Opens the report window by updating the global store's state.
   *
   * @return*/
  openReportWindow() {
    this.globalStore.setOpenReport();
  }

  init() {
    // backup
    //const availableData = this.dataStore.getGroupedByIndicators(
    //  this.indicatorStore.allIds()
    //);
    //this.buildLayerMenu(availableData);
  }

  private buildLayerMenu(
    availableData: Record<string, Record<string, IndicatorData>>
  ) {
    this.dataLayerMenu = [];
    for (const typeId in availableData) {
      const typeDataGroupedByLayerId = availableData[typeId];
      const type = this.typeStore.getById(typeId);
      const typeLayerItems: MenuItem[] = [];
      for (const layerId in typeDataGroupedByLayerId) {
        const layer = this.layerStore.getById(layerId);
        if (!layer.geoData) continue;
        const kv = this.geoStore.getDistrictsById(layer.geoData);
        if (!kv) continue;
        const districts: MenuItem[] = [];
        for (const key in kv) {
          const feature = kv[key];
          districts.push({
            icon: 'fas fa-map-location-dot',
            label: feature.name,
            id: key,
            command: () => {
              this.globalStore.setActiveReport(layerId, key);
            },
            //routerLink: [{ outlets: { reports: [layerId, key] } }],
          });
        }

        typeLayerItems.push({
          icon: 'fas fa-calendar-days',
          label: layer.year + '',
          id: layerId,
          items: districts,
        });
      }

      this.dataLayerMenu.push({
        icon:
          type.type === 'Point' ? 'fas fa-location-dot' : 'fa-regular fa-map',
        label: type.name,
        items: typeLayerItems,
      });
    }
  }
}
